import {useEffect, useState} from 'react';
import {Link} from 'react-router';
import {Card, Col, Row, Table} from "antd";
import {toUtcDateString} from "../../util/timeutils";
import {getPurchaseOrderLineCreation} from "../../api/Api";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const CompletedPOLineItemView = ({item, onApiFail, refresh, onRefresh, props}) => {
    const [ingredients, setIngredients] = useState([]);

    useEffect(() => {
        getPurchaseOrderLineCreation(item.id).then(r => {
            console.log(`got ${JSON.stringify(r)}`);
            setIngredients(r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            }))
        });
    }, [onApiFail, item.id]);

    const {completedByUser, completed, hours, quantityCreated, inventoryId, bookQuantity, bookInventoryId} = item;

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Used',
            dataIndex: 'quantity',
            key: 'used',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return displayQuantity;
            }
        },
        {
            title: 'Waste',
            dataIndex: 'waste',
            key: 'waste',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return displayQuantity;
            }
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        }
    ]

    const rowStyle={textAlign: 'left', marginTop: '5px', marginBottom: '5px'}
    let ingredientsContent;
    if (ingredients.length > 0) {
        ingredientsContent = <Table dataSource={ingredients} columns={columns} pagination={false} />
    } else {
        ingredientsContent = <div style={{color: "#108ee9"}}>No Ingredients Reported</div>
    }

    return <div style={{textAlign: 'left'}}>
        <Card title={'Requested Product'}>
            <Row style={rowStyle}>
                <Col span={2}><b>Product:</b></Col>
                <Col>{item.quantity} <b>{item.name}</b></Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}><b>Completed By:</b></Col>
                <Col>{completedByUser}</Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}><b>Timestamp:</b></Col>
                <Col>{toUtcDateString(new Date(completed))}</Col>
            </Row>
        </Card>
        <Card title={'Ingredients'}>
            {ingredientsContent}
        </Card>
        { (quantityCreated > 0) && (inventoryId !== null) &&
        <Card title={`Created Inventory`}>
            {(quantityCreated > 0) &&
            <Row>
                <Col span={4}><b>Quantity Created:</b></Col>
                <Col>{quantityCreated}</Col>
            </Row>
            }
            {(quantityCreated > 0) &&
            <Row>
                <Col span={4}><b>Inventory Created:</b></Col>
                <Col><Link to={`/inventory/${inventoryId}`}>Inventory</Link></Col>
            </Row>
            }
            {(bookQuantity > 0) &&
                <Row>
                    <Col span={4}><b>Book Quantity:</b></Col>
                    <Col>{bookQuantity}</Col>
                </Row>
            }
            {(bookQuantity > 0) &&
                <Row>
                    <Col span={4}><b>Book Inventory:</b></Col>
                    <Col><Link to={`/inventory/${bookInventoryId}`}>Book Inventory</Link></Col>
                </Row>
            }
        </Card>
        }
        <Card title={`Labor`}>
            <Row style={rowStyle}>
                <Col span={2}><b>Hours:</b></Col>
                <Col>{hours}</Col>
            </Row>
        </Card>
    </div>
}